import SkeletonLoader from "@/Layout/SkeletonLoader"

const PrimaryButton = (props) => {
    const { customClass, buttonType, title, children, disabled, onClick, skeletonLoading, width } = props
    return (
        <>
            {skeletonLoading ? <SkeletonLoader height={50} rows={1} width={width ? width : '200'} /> :
                <button
                    type={buttonType}
                    disabled={disabled}
                    onClick={onClick}
                    className={`${customClass} relative inline-flex items-center justify-center rounded-xl h-10 sm:px-6 px-5 2xl:text-sm text-xs font-semibold text-white bg-gradient-to-br from-primary to-accent shadow-float hover:shadow-pop hover:-translate-y-0.5 active:translate-y-0 active:shadow-soft focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/25 transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0 disabled:hover:shadow-float`}
                >
                    {children ? children : title}
                </button>}
        </>
    )
}

export default PrimaryButton
